import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import './style.css'
import NavMenuContent from './NavMenuContent';

const SidebarMenuSearchBox = ({ styleName, placeholder, value }) => {
  const { formatMessage } = useIntl(); 
  const boxRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState('');
  const reportDataFromStore = useSelector(({ auth }) => auth.authUser);
  const reportData = {...reportDataFromStore, terms: []};
  const [menuItems, setMenuItems] = useState({});
  const [showNavMenu, setShowNavMenu] = useState(false);
  const routeUrl = useLocation();


  const idPrefixes = {
    reports : 'dashboard.report',
    historical: 'dashboard.history',
    subsc: 'dashboard.subscriptions',
    analytics: 'dashboard.analytics',
    resources: 'dashboard.resources',
    ezcharge: 'dashboard.EZCharge',
    ezcredits: 'dashboard.ApproveBills',
    manageorders: 'dashboard.orders',
    freerequests: 'dashboard.freerequests',
    appointments: 'dashboard.appointments',
    valetreimbursements: 'dashboard.valet.reimbursements',
    attendants: 'dashboard.attendants',
    logs: 'dashboard.logs',
    parkezads: 'dashboard.parkezAds',
    valet: 'dashboard.valet',
    valetv2: 'dashboard.valetv2',
    access: 'dashboard.access',
    users: 'dashboard.users',
    jobs: 'dashboard.job',
    terms: 'dashboard.terms',
  }
  
  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchTerm(e.target.value.toLowerCase());

    if(searchTerm != ''){
      const filteredReportDataList = Object.entries(reportData).reduce((acc, [key, value]) => {
       
        const tempMenu = value.filter((item) => {
          const translatedName = formatMessage({ id: `${idPrefixes[key]}.${item.name}` });
          return translatedName.toLowerCase().includes(searchTerm.toLowerCase());
        });

        if (tempMenu.length > 0) {
          acc[key] = tempMenu;
        } 
        
        const translatedMenuName = formatMessage({ id: `${idPrefixes[key]}` });
        if(key== 'subsc'){
          console.log("Subscription______", translatedMenuName );
        }
        if(translatedMenuName.toLowerCase().includes(searchTerm.toLowerCase())){
          acc[key] = reportData[key];
        }
        
        return acc;
      }, {});

      setMenuItems(filteredReportDataList);
    } else{
      setMenuItems({});
    }
  };

  useEffect(() => {
    setShowNavMenu(false);
    if(Object.keys(menuItems).length > 0){
      setTimeout(() => setShowNavMenu(true), 0);
    } else setShowNavMenu(false);
  }, [menuItems]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setShowNavMenu(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(()=>{
    setShowNavMenu(false);
    setSearchTerm('');
    setMenuItems({});
  },[routeUrl.pathname])

  return (
    <div className="sidebar-menu-search-box" ref={boxRef}>
      <aside className='raltive' >
        <input
          className="search-input"
          placeholder={placeholder}
          onChange={handleSearch}
          value={searchTerm}
          fullWidth       
          style={{ margin:'5px', minWidth:'22vw'}}
        />
          { showNavMenu &&
            <div className="search-dropdown">
              <NavMenuContent reportData={menuItems} searchTerm={searchTerm}/>
            </div>
          }
      </aside>
    </div>
  );
};

export default SidebarMenuSearchBox;

SidebarMenuSearchBox.defaultProps = {
  styleName: "",
  value: "",
  placeholder: "Search..."
};
